// extracted by mini-css-extract-plugin
export default {"imageOval":"Image_imageOval__rNV0I","imageSquare":"Image_imageSquare__5VoEq","imageRectangle":"Image_imageRectangle__M-GIT"};